
import { serializable, alias, object, list, primitive } from 'serializr';

export class _DashboardFilterModel {
    @serializable(alias('InstId', primitive()))
    institute?: number;

    @serializable(alias('BranchId', primitive()))
    branch?: number;

    @serializable(alias('BoardId', primitive()))
    board?: number;

    @serializable(alias('GradeId', primitive()))
    classRoom?: number;

    @serializable(alias('BranchClassRoom', primitive()))
    branchClassRoom?: number;

    @serializable(alias('StartDate', primitive()))
    startingDate?: string;


    @serializable(alias('EndDate', primitive()))
    endingDate?: string;
}

